var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnbIco06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7852 14.6855L13.2959 19.1699C13.1534 19.3123 12.9754 19.4133 12.7773 19.4619L10.6895 19.9824C10.4983 20.031 10.3001 19.9759 10.1611 19.8369C10.0222 19.698 9.96699 19.4996 10.0156 19.3086L10.5361 17.2217C10.5847 17.0273 10.6858 16.8465 10.8281 16.7041V16.707L15.3174 12.2197L17.7852 14.6855ZM10.4902 7.70703C10.4902 8.21957 10.9043 8.63361 11.417 8.63379H15.126V10.4941L9.83008 15.7891C9.53171 16.0874 9.32308 16.4579 9.22168 16.8662L8.67969 19.0352C8.61305 19.3016 8.62795 19.5801 8.71777 19.832L5.85449 19.8291C4.83174 19.8291 4.00004 18.998 4 17.9756V5.85352C4.00007 4.83117 4.83176 4 5.85449 4H10.4902V7.70703ZM17.1279 10.4102C17.67 9.8683 18.5492 9.8683 19.0947 10.4102L19.5947 10.9102C20.1368 11.452 20.1368 12.3307 19.5947 12.876L18.5732 13.8975L16.1064 11.4307L17.1279 10.4102ZM15.126 7.70703H11.417V4L15.126 7.70703Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIco06);
export default __webpack_public_path__ + "static/media/Gnb_ico_06.14ef028457673ca046a04ee0c6e799e1.svg";
export { ForwardRef as ReactComponent };